import { NavLink, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, ShoppingCart, Palette, Compass } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { useLanguage } from '@/context/LanguageContext';

const ITEMS = [
  { to: '/', key: 'mobileNav.home', fallback: 'Home', icon: Home, end: true, testId: 'mobile-nav-home' },
  { to: '/designs', key: 'mobileNav.designs', fallback: 'Designs', icon: Palette, testId: 'mobile-nav-designs' },
  { to: '/community', key: 'nav.community', fallback: 'Community', icon: Compass, testId: 'mobile-nav-explore' },
  { to: '/cart', key: 'mobileNav.cart', fallback: 'Cart', icon: ShoppingCart, testId: 'mobile-nav-cart', badgeKey: 'cart' },
  { to: '/orders', key: 'nav.orders', fallback: 'Orders', icon: ShoppingBag, testId: 'mobile-nav-orders' },
];

// Routes that should hide the mobile bottom nav (design editor, auth callback).
const HIDE_ON = [/^\/design\/[^/]+$/, /^\/auth\//];

const MobileBottomNav = () => {
  const location = useLocation();
  const { cart } = useCart();
  const { t } = useLanguage();

  if (HIDE_ON.some((re) => re.test(location.pathname))) return null;

  const cartCount = (cart?.items || []).reduce((s, i) => s + (i.quantity || 0), 0);

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t backdrop-blur-xl"
      style={{
        borderColor: 'var(--jw-border)',
        background: 'color-mix(in oklab, var(--jw-bg-alt) 85%, transparent)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <ul className="grid grid-cols-5">
        {ITEMS.map((it) => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              end={it.end}
              data-testid={it.testId}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 h-14 text-[10px] transition-colors relative ${isActive ? 'jw-gradient-text font-semibold' : ''}`
              }
              style={({ isActive }) => ({ color: isActive ? undefined : 'var(--jw-text-muted)' })}
            >
              {({ isActive }) => (
                <>
                  <span className="relative">
                    <it.icon className={`w-5 h-5 ${isActive ? 'text-orange-400' : ''}`} />
                    {it.badgeKey === 'cart' && cartCount > 0 && (
                      <span
                        data-testid="mobile-nav-cart-badge"
                        className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold text-white grid place-items-center jw-gradient-bg"
                      >
                        {cartCount > 99 ? '99+' : cartCount}
                      </span>
                    )}
                  </span>
                  <span>{t(it.key, it.fallback)}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MobileBottomNav;
